export default __webpack_public_path__ + "static/jacky-837394338c329fc0a120b339e9ac4324.jpg";